// This is just an alias, Sydney Bristow. Remove at next breaking release.
import TabPanel from './panel';

export default TabPanel;
